export const LOCATION_LIST_REQUEST = 'LOCATION_LIST_REQUEST';
export const LOCATION_LIST_SUCCESS = 'LOCATION_LIST_SUCCESS';
export const LOCATION_LIST_FAIL = 'LOCATION_LIST_FAIL';
export const LOCATION_LIST_RESET = 'LOCATION_LIST_RESET';


export const STATE_CREATE_REQUEST = 'STATE_CREATE_REQUEST';
export const STATE_CREATE_SUCCESS = 'STATE_CREATE_SUCCESS';
export const STATE_CREATE_FAIL = 'STATE_CREATE_FAIL';

export const STATE_LIST_REQUEST = 'STATE_LIST_REQUEST';
export const STATE_LIST_SUCCESS = 'STATE_LIST_SUCCESS';
export const STATE_LIST_FAIL = 'STATE_LIST_FAIL';
export const STATE_LIST_RESET = 'STATE_LIST_RESET';

export const STATE_DELETE_REQUEST = 'STATE_DELETE_REQUEST';
export const STATE_DELETE_SUCCESS = 'STATE_DELETE_SUCCESS';
export const STATE_DELETE_FAIL = 'STATE_DELETE_FAIL';

export const STATE_DETAILS_REQUEST = 'STATE_DETAILS_REQUEST';
export const STATE_DETAILS_SUCCESS = 'STATE_DETAILS_SUCCESS';
export const STATE_DETAILS_FAIL = 'STATE_DETAILS_FAIL';
export const STATE_DETAILS_RESET = 'STATE_DETAILS_RESET';

export const STATE_UPDATE_REQUEST = 'STATE_UPDATE_REQUEST';
export const STATE_UPDATE_SUCCESS = 'STATE_UPDATE_SUCCESS';
export const STATE_UPDATE_FAIL = 'STATE_UPDATE_FAIL';
export const STATE_UPDATE_RESET = 'STATE_UPDATE_RESET';


export const LGA_CREATE_REQUEST = 'LGA_CREATE_REQUEST';
export const LGA_CREATE_SUCCESS = 'LGA_CREATE_SUCCESS';
export const LGA_CREATE_FAIL = 'LGA_CREATE_FAIL';

export const LGA_LIST_REQUEST = 'LGA_LIST_REQUEST';
export const LGA_LIST_SUCCESS = 'LGA_LIST_SUCCESS';
export const LGA_LIST_FAIL = 'LGA_LIST_FAIL';
export const LGA_LIST_RESET = 'LGA_LIST_RESET';

export const LGA_DELETE_REQUEST = 'LGA_DELETE_REQUEST';
export const LGA_DELETE_SUCCESS = 'LGA_DELETE_SUCCESS';
export const LGA_DELETE_FAIL = 'LGA_DELETE_FAIL';

export const LGA_DETAILS_REQUEST = 'LGA_DETAILS_REQUEST';
export const LGA_DETAILS_SUCCESS = 'LGA_DETAILS_SUCCESS';
export const LGA_DETAILS_FAIL = 'LGA_DETAILS_FAIL';
export const LGA_DETAILS_RESET = 'LGA_DETAILS_RESET';

export const LGA_UPDATE_REQUEST = 'LGA_UPDATE_REQUEST';
export const LGA_UPDATE_SUCCESS = 'LGA_UPDATE_SUCCESS';
export const LGA_UPDATE_FAIL = 'LGA_UPDATE_FAIL';
export const LGA_UPDATE_RESET = 'LGA_UPDATE_RESET';
